import React from "react";
import { Helmet } from "react-helmet";
import { useDispatch} from 'react-redux';
import { userLogout } from '../../features/userSlicer';
import { Link, useNavigate } from 'react-router-dom';
import avatar from './avatar.png';
import logo from "../assets/image/logo.png";
const backend_url= process.env.REACT_APP_BASE_URL;

export default function UserHeader({user}) {
  const dispatch=useDispatch();



  return (
    <>
      <Helmet>
        
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Dashboard - Flexiva</title>

        <meta name="description" content="" />
        <meta name="author" content="Pro Nauman" />
        <link rel="shortcut icon" href="/img/favicon.png" />
        <link
          rel="stylesheet"
          href="/user/assets/fonts/bootstrap/bootstrap-icons.css"
        />
        <link rel="stylesheet" 
        href="/user/assets/css/main.min.css" />
      </Helmet>

      <>
  {/* App header starts */}
  <div className="app-header d-flex align-items-center">
    {/* Toggle buttons start */}
    <div className="d-flex col">
      <button className="toggle-sidebar text-dark" id="toggle-sidebar">
        <i className="bi bi-list lh-1 text-dark" />
      </button>
      <button className="pin-sidebar" id="pin-sidebar">
        <i className="bi bi-list lh-1 text-dark" />
      </button>
    </div>
    {/* Toggle buttons end */}
    {/* App brand starts */}
    <div className="app-brand py-2 col">
      <Link to="/user/dashboard">
      <div className="logo">
              <Link to={"/"}>
                <img src={logo} alt="logo" />
              </Link>
            </div>
      </Link>
    </div>
    {/* App brand ends */}
    {/* App header actions start */}
    <div className="header-actions col">
      <div className="d-lg-flex d-none align-items-center gap-2">
        {/* <div className="dropdown">
          <a
            className="dropdown-toggle header-action-icon text-dark"
            href="#!"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-exclamation-triangle fs-5 lh-1 text-dark" />
            <span className="count-label">7</span>
          </a>
          <div className="dropdown-menu dropdown-menu-end shadow-lg">
            <h5 className="fw-semibold px-3 py-2 text-dark">Notifications</h5>
            <div className="dropdown-item">
              <div className="d-flex py-2 border-bottom">
                <div className="icon-box md bg-success rounded-circle me-3">
                  <i className="bi bi-exclamation-triangle text-dark fs-4" />
                </div>
                <div className="m-0">
                  <h6 className="mb-1 fw-semibold">Rosalie Deleon</h6>
                  <p className="mb-1 text-secondary">You have new order.</p>
                  <p className="small m-0 text-secondary">30 mins ago</p>
                </div>
              </div>
            </div>
            <div className="dropdown-item">
              <div className="d-flex py-2 border-bottom">
                <div className="icon-box md bg-danger rounded-circle me-3">
                  <i className="bi bi-exclamation-octagon text-dark fs-4" />
                </div>
                <div className="m-0">
                  <h6 className="mb-1 fw-semibold">Donovan Stuart</h6>
                  <p className="mb-2">Membership has been expired.</p>
                  <p className="small m-0 text-secondary">2 days ago</p>
                </div>
              </div>
            </div>
            <div className="dropdown-item">
              <div className="d-flex py-2">
                <div className="icon-box md bg-warning rounded-circle me-3">
                  <i className="bi bi-exclamation-square text-dark fs-4" />
                </div>
                <div className="m-0">
                  <h6 className="mb-1 fw-semibold">Roscoe Richards</h6>
                  <p className="mb-2">Payment pending. Pay now.</p>
                  <p className="small m-0 text-secondary">3 days ago</p>
                </div>
              </div>
            </div>
            <div className="d-grid mx-3 my-1">
              <a href="javascript:void(0)" className="btn btn-info">
                View all
              </a>
            </div>
          </div>
        </div> */}
        {/* <div className="dropdown">
          <a
            className="dropdown-toggle header-action-icon text-dark"
            href="#!"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="bi bi-bell fs-5 lh-1 text-dark" />
          </a>
          <div className="dropdown-menu dropdown-menu-end shadow-lg">
            <h5 className="fw-semibold px-3 py-2 text-primary">Updates</h5>
            <div className="dropdown-item">
              <div className="d-flex py-2 border-bottom">
                <div className="icon-box md border border-success grd-success-light rounded-circle me-3">
                  <span className="text-success">DS</span>
                </div>
                <div className="m-0">
                  <h6 className="mb-1 fw-semibold">Douglass Shaw</h6>
                  <p className="mb-1 text-secondary">
                    Membership has been ended.
                  </p>
                  <p className="small m-0 text-secondary">Today, 07:30pm</p>
                </div>
              </div>
            </div>
            <div className="dropdown-item">
              <div className="d-flex py-2 border-bottom">
                <div className="icon-box md border border-danger grd-danger-light rounded-circle me-3">
                  <span className="text-danger">WG</span>
                </div>
                <div className="m-0">
                  <h6 className="mb-1 fw-semibold">Willie Garrison</h6>
                  <p className="mb-1 text-secondary">
                    Congratulate, James for new job.
                  </p>
                  <p className="small m-0 text-secondary">Today, 08:00pm</p>
                </div>
              </div>
            </div>
            <div className="dropdown-item">
              <div className="d-flex py-2">
                <div className="icon-box md border border-warning grd-warning-light rounded-circle me-3">
                  <span className="text-warning">TJ</span>
                </div>
                <div className="m-0">
                  <h6 className="mb-1 fw-semibold">Terry Jenkins</h6>
                  <p className="mb-1 text-secondary">
                    Lewis added new schedule release.
                  </p>
                  <p className="small m-0 text-secondary">Today, 09:30pm</p>
                </div>
              </div>
            </div>
            <div className="d-grid mx-3 my-1">
              <a href="javascript:void(0)" className="btn btn-info">
                View all
              </a>
            </div>
          </div>
        </div> */}
      </div>
      <div className="dropdown ms-3">
        <a
          id="userSettings"
          className="dropdown-toggle d-flex py-2 align-items-center text-decoration-none"
          href="#!"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img
           src={user?.avatar ? `${backend_url}/images/${user?.avatar}` : avatar}
            className="rounded-2 img-3x"
            alt="Bootstrap Gallery"
          />
          <div className="ms-2 text-truncate d-lg-block d-none text-dark">
            {/* <span class="d-flex opacity-50 small">Admin</span> */}
            <span>{user?.fullName ? user?.fullName :"null"}</span>
            <p>{"FLX-"+ user?._id?.slice(-5).toUpperCase()}</p>
          </div>
        </a>
        <div className="dropdown-menu dropdown-menu-end shadow-lg">
          <div className="header-action-links">
            <Link className="dropdown-item" to="/user/settings">
              <i className="bi bi-person border border-primary text-primary" />
              Profile
            </Link>
            <Link className="dropdown-item" to="/user/settings">
              <i className="bi bi-gear border border-danger text-danger" />
              Settings
            </Link>
          </div>
          <div className="mx-3 mt-2 d-grid">
            <Link onClick={()=>dispatch(userLogout())} className="btn btn-primary btn-sm">
              Logout
            </Link>
          </div>
        </div>
      </div>
    </div>
    {/* App header actions end */}
  </div>
  {/* App header ends */}
</>

    </>
  );
}
